import type { WillCallEmailAttributes as GQLInput } from '../../generated/api.graphql';
import { take } from '../../util/takePayload';

export type SendWillCallEmailsInput = {
  eventId: number;
  subject: string;
  content: string;
  resendTickets?: boolean;
  bccEmails?: string[];
  ticketBlueprintId?: number;
};

export const toGqlInput = (gqlInput: SendWillCallEmailsInput): GQLInput =>
  take(gqlInput, 'eventId', 'subject', 'content', 'resendTickets', 'ticketBlueprintId', 'bccEmails');
